import type { BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { DISPENSARY_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useCrbConfirmBeneficialOwner(dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: confirmBeneficialOwner, isPending: isConfirmingBeneficialOwner } = useMutation({
    mutationKey: [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
    mutationFn: ({
      beneficialOwnerId,
      templateResultId,
      confirmation
    }: {
      beneficialOwnerId: string;
      templateResultId: string;
      confirmation: boolean;
    }) =>
      beneficialOwnerApi.crbConfirmBeneficialOwner(
        dispensaryId,
        beneficialOwnerId,
        templateResultId,
        confirmation
      ),
    onSuccess: (updatedOwner) => {
      return queryClient.setQueryData(
        [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
        (old: BeneficialOwnerResponse[] | undefined) =>
          old?.map((owner) => (owner.id === updatedOwner.id ? updatedOwner : owner))
      );
    },
    meta: {
      snackbarErrorMessage: 'There was an issue confirming beneficial owner selection.'
    }
  });

  return { confirmBeneficialOwner, isConfirmingBeneficialOwner };
}
